import { Block } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const TruncatedText = ({ children }: PropsWithChildren) => (
  <Block
    __dangerDoNotUseSx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </Block>
);
